<div class="filter-dropdown p-2">
    <app-ls-search-input *ngIf="columnConfig?.type!='date'" (onSearch)="onSearch($event)"></app-ls-search-input>
    <app-ls-search-input *ngIf="columnConfig?.type==='date'" (onSearch)="onSearch($event)" [isDatePicker]="true"></app-ls-search-input>

    <div class="unique-list my-3" infinite-scroll [scrollWindow]="false" [alwaysCallback]="true" [infiniteScrollThrottle]="0"
              [infiniteScrollUpDistance]="1" (scrolled)="onInfiniteScroll()">
        <div *ngIf="!isSearchActive && fullList.length > 0">
            <div *ngIf="filteredList.length > 0; else noData">
                <div class="form-check pb-2">
                    <input class="form-check-input" type="checkbox" id="select-all" [checked]="areAllSelected()"
                        (change)="toggleSelectAll($event)" />
                    <label class="form-check-label" for="select-all">
                        {{"Select All"}}
                    </label>
                </div>
                <div class="form-check" *ngFor="let item of filteredList; let last = last; let first = first" [ngClass]="{
                    'pb-0 pt-2': last,
                    'py-2': !last
                }">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="item.checked"
                        id="checkbox-{{item?.value}}" (change)="syncAndMergeCheckedItems(this.fullList,this.searchedResults,'full')" />
                    <label class="form-check-label" for="checkbox-{{item?.value}}">
                        <ng-container *ngIf="item?.type == 'string'">{{ item?.text }}</ng-container>
                        <ng-container *ngIf="item?.type == 'currency'">{{ (item?.text) | currency
                            }}</ng-container>
                        <ng-container *ngIf="item?.type == 'date'">{{ item?.text | date: DATE_FORMAT_MMDDYYYY
                            }}</ng-container>
                    </label>
                </div>
            </div>
        </div>
        <div *ngIf="isSearchActive">
            <div *ngIf="searchedResults.length > 0 && isSearchActive; else noData">
                <div class="form-check pb-2">
                    <input class="form-check-input" type="checkbox" id="select-all" [checked]="areAllSearchedSelected()"
                        (change)="toggleSelectAll($event)" />
                    <label class="form-check-label" for="select-all">
                        {{"Select All Search Results"}}
                    </label>
                </div>
                <div class="form-check" *ngFor="let item of searchedResults; let last = last; let first = first" [ngClass]="{
                    'pb-0 pt-2': last,
                    'py-2': !last
                }">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="item.checked"
                        id="checkbox-{{item?.value}}" (change)="syncAndMergeCheckedItems(this.fullList,this.searchedResults,'searched')"/>
                    <label class="form-check-label" for="checkbox-{{item?.value}}">
                        <ng-container *ngIf="item?.type == 'string'">{{ item?.text }}</ng-container>
                        <ng-container *ngIf="item?.type == 'currency'">{{ (item?.text) | currency
                            }}</ng-container>
                        <ng-container *ngIf="item?.type == 'date'">{{ item?.text | date: DATE_FORMAT_MMDDYYYY
                            }}</ng-container>
                    </label>
                </div>
            </div>
        </div>

        <ng-template #noData>
            <div class="d-flex justify-content-center align-items-center text-muted h-100">No items found</div>
        </ng-template>
    </div>
    <!-- <div> merged list :
        <div class="form-check" *ngFor="let item of mergedList; let last = last; let first = first" [ngClass]="{
                    'pb-0 pt-2': last,
                    'py-2': !last
                }">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="item.checked"
                        id="checkbox-{{item?.value}}" />
                    <label class="form-check-label" for="checkbox-{{item?.value}}">
                        <ng-container *ngIf="item?.type == 'string'">{{ item?.text }}</ng-container>
                        <ng-container *ngIf="item?.type == 'currency'">{{ (item?.text) | currency
                            }}</ng-container>
                        <ng-container *ngIf="item?.type == 'date'">{{ item?.text | date: DATE_FORMAT_MMDDYYYY
                            }}</ng-container>
                    </label>
                </div>

    </div> -->

    <div class="d-flex justify-content-end align-items-center">
        <a href="javascript:;" class="text-underline export-link mr-2" (click)="reset()">{{"Reset"|translate}}</a>&thinsp;
        <button class="btn btn-success mr-2" (click)="onSave()" [disabled]="( !isAnySelected() ) || filteredList.length === 0">OK</button>
        <button class="btn btn-success" (click)="onCancel()">Close</button>
    </div>
</div>